import { combineReducers } from 'redux'
import {APP_RESET_STATE} from '../actions/app'
import { reducer as form } from 'redux-form'
import Router from './router'
import NavDraw from './nav-draw'
import Auth from './auth'
import Messaging from './messaging'
import Budgeting from './budgeting'
import Balances from './balances'
import Loading from './loading'
import CreatePIN from './create-pin'
import Notify from './notify'
import AustraliaPost from './australia-post'
import Preferences from './preferences'
import History from './history'
import Features from './features'
import Payment from './payment'

const reducers = {
	Router,
	NavDraw,
	Auth,
	Messaging,
	Notify,
	Budgeting,
	Balances,
	Loading,
	CreatePIN,
	AustraliaPost,
	Preferences,
	History,
	Features,
	Payment,
	form // Lower case as the library expects this
}

export default function createReducers(reducerFilter = undefined){
	let ourReducers = reducers
	if(reducerFilter){
		ourReducers = reducerFilter(ourReducers)
	}

	const appReducer = combineReducers(ourReducers)

	return (state, action) => {
		if(action.type === APP_RESET_STATE){
			action.payload = state
			return appReducer(undefined, action)
		}

		return appReducer(state, action)
	}
}





// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/index.js